const getEncodedValue = (value) => value.replace(/&/g, '%26').replace(/ |%20/g, '+').replace(/%22/g, '"');

export default getEncodedValue;
